import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { motion, AnimatePresence } from 'framer-motion'
import { mainThemes, chatThemes } from 'utils/constants'
import ThemeList from './ThemeList'

const ThemeDropdown = ({ hasText = false }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { pathname } = useRouter()
  const { activeChatTheme, activeTheme } = useSelector((state) => state.theme)

  const isChatPage = pathname === '/chat'
  const themesList = isChatPage ? chatThemes : mainThemes
  const activeThemeName = isChatPage ? activeChatTheme : activeTheme

  // const isDarkTheme = isChatPage && activeChatTheme !== 'theme5'

  // Find the active theme label to display
  // const activeThemeLabel = themesList.find((theme) => theme.value === activeThemeName)?.label || 'Theme'

  const toggleDropdown = () => setIsOpen(!isOpen)

  return (
    <div className="relative">
      <div className="flex items-center gap-1 cursor-pointer">
        <img
          onClick={toggleDropdown}
          className={`min-w-[25px] min-h-[25px] w-[25px] h-[25px] inline-block ${activeChatTheme != 'theme5' ? 'invert' : ''}`}
          alt="theme"
          src={
            pathname == '/chat'
              ? activeChatTheme == 'theme5'
                ? '/assets/chat/moon.svg'
                : '/assets/chat/fill-moon.svg'
              : '/assets/chat/moon.svg'
          }
        />
        {hasText && <span>Themes</span>}
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="absolute right-0 mt-3 z-50 min-w-48"
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
          >
            <ThemeList
              type={isChatPage ? 'chat' : 'main'}
              themesList={themesList}
              activeTheme={activeThemeName}
              onClose={() => setIsOpen(false)}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default ThemeDropdown
